import { inheritsLoose as _inheritsLoose, extends as _extends, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Boutton from '@piconetworks/pkg-boutton';
import Form from '@piconetworks/pkg-form';
import Spacing from '@piconetworks/pkg-spacing';
import Otp from '@piconetworks/pkg-field-otp';
import SocialLogin from '@piconetworks/pkg-field-social-login';
import SocialLoginButton from '@piconetworks/pkg-social-login-button';
import { PICO_API_URL } from '@piconetworks/pkg-endpoints';
import style from '../scss/EmailPasswordSocialNewslettersLogin.module.scss.js';

var _excluded = ["meta", "input"];
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    console.log('getDerivedStateFromError', error);
    return {
      hasError: true
    };
  };
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    console.error(error.message, errorInfo);
  };
  _proto.render = function render() {
    var hasError = this.state.hasError;
    var _this$props = this.props,
      children = _this$props.children,
      _this$props$RenderErr = _this$props.RenderError,
      RenderError = _this$props$RenderErr === void 0 ? function () {
        return /*#__PURE__*/React.createElement("div", {
          className: "errorBoundaree"
        });
      } : _this$props$RenderErr;
    if (hasError) {
      return /*#__PURE__*/React.createElement(RenderError, null);
    }
    return children;
  };
  return ErrorBoundary;
}(React.Component);
var testEmail = function testEmail(email) {
  if (!email) {
    return false;
  }
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(email);
};
var fieldValidations = {
  email: function email(value) {
    return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(value.trim()) ? 'Invalid email address' : undefined;
  }
};
var composeValidators = function composeValidators() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }
  return function (value) {
    return validators.reduce(function (error, validator) {
      return error || validator(value);
    }, undefined);
  };
};
var invalidCustomFieldsError = 'Please fill out the required fields above.';
var EmailPasswordSocialNewslettersLogin = function EmailPasswordSocialNewslettersLogin(_temp) {
  var _cx2;
  var _ref = _temp === void 0 ? {} : _temp,
    access_token = _ref.access_token,
    _ref$authenticationMe = _ref.authenticationMethods,
    authenticationMethods = _ref$authenticationMe === void 0 ? [] : _ref$authenticationMe,
    checkEmail = _ref.checkEmail,
    confirmCode = _ref.confirmCode,
    _ref$contrastColor = _ref.contrastColor,
    contrastColor = _ref$contrastColor === void 0 ? '' : _ref$contrastColor,
    _ref$isCustomFieldsVa = _ref.isCustomFieldsValid,
    isCustomFieldsValid = _ref$isCustomFieldsVa === void 0 ? true : _ref$isCustomFieldsVa,
    values = _ref.values,
    email = _ref.email,
    fieldContainerProps = _ref.fieldContainerProps,
    isPaymentLandingPage = _ref.isPaymentLandingPage,
    isNewRegistration = _ref.isNewRegistration,
    isReturningUser = _ref.isReturningUser,
    _ref$linkColor = _ref.linkColor,
    linkColor = _ref$linkColor === void 0 ? '' : _ref$linkColor,
    name = _ref.name,
    oneTimeCodeError = _ref.oneTimeCodeError,
    _ref$oneTimeCodeSent = _ref.oneTimeCodeSent,
    oneTimeCodeSent = _ref$oneTimeCodeSent === void 0 ? false : _ref$oneTimeCodeSent,
    onSocialLogin = _ref.onSocialLogin,
    _ref$onSubmitCallback = _ref.onSubmitCallback,
    onSubmitCallback = _ref$onSubmitCallback === void 0 ? function () {} : _ref$onSubmitCallback,
    origin = _ref.origin,
    popupId = _ref.popupId,
    _ref$previewMode = _ref.previewMode,
    previewMode = _ref$previewMode === void 0 ? false : _ref$previewMode,
    publisherId = _ref.publisherId,
    resendOneTimeCode = _ref.resendOneTimeCode,
    resetOneTimeCode = _ref.resetOneTimeCode,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? false : _ref$showError,
    _ref$showTerms = _ref.showTerms,
    showTerms = _ref$showTerms === void 0 ? false : _ref$showTerms,
    onSkipOtp = _ref.onSkipOtp,
    _ref$updateAccountErr = _ref.updateAccountError,
    updateAccountError = _ref$updateAccountErr === void 0 ? {} : _ref$updateAccountErr,
    userId = _ref.userId,
    username = _ref.username,
    utm = _ref.utm,
    setFlow = _ref.setFlow,
    _errorMessage = _ref.errorMessage,
    _ref$getErrorText = _ref.getErrorText,
    getErrorText = _ref$getErrorText === void 0 ? function (e) {
      return e;
    } : _ref$getErrorText,
    isAuthenticated = _ref.isAuthenticated;
  var _useState = useState(_errorMessage),
    errorMessage = _useState[0],
    setErrorMessage = _useState[1];
  var _useState2 = useState(null),
    selectedSSO = _useState2[0],
    setSelectedSSO = _useState2[1];
  var _useState3 = useState(!oneTimeCodeSent || !email),
    enterEmail = _useState3[0],
    setEnterEmail = _useState3[1];
  var emailInputRef = useRef(null);
  var requestNewCode = useCallback(function () {
    setEnterEmail(true);
    resetOneTimeCode();
  }, []);
  useEffect(function () {
    setErrorMessage(_errorMessage);
  }, [_errorMessage]);
  useEffect(function () {
    if (selectedSSO) {
      setErrorMessage(null);
    }
  }, [selectedSSO]);
  useEffect(function () {
    if (updateAccountError.message) {
      setErrorMessage(updateAccountError.message);
    }
  }, [updateAccountError]);
  var processEmail = async function processEmail(email) {
    email = email && email.trim();
    try {
      if (isCustomFieldsValid || isReturningUser) {
        setFlow({
          flow: 'email'
        });
        if (testEmail(email)) {
          await checkEmail({
            email: email,
            customProperties: values === null || values === void 0 ? void 0 : values.customFields,
            selectedNewsletters: (values === null || values === void 0 ? void 0 : values.newsletters) || [],
            shouldUpdate: isAuthenticated
          });
        }
        setEnterEmail(false);
      } else {
        setErrorMessage(invalidCustomFieldsError);
      }
    } catch (error) {
      setErrorMessage(error.message);
    }
  };
  var onEnterEmail = function onEnterEmail(e, emailAddress) {
    if (errorMessage) {
      setErrorMessage(null);
    }
    if (e.key === 'Enter' && !previewMode) {
      e.preventDefault();
      processEmail(emailAddress);
    }
  };
  var emailInputOnFocus = function emailInputOnFocus() {
    setSelectedSSO(null);
  };
  var handleDummySSOClick = function handleDummySSOClick(provider) {
    setSelectedSSO(provider);
  };
  var renderSignupButton = function renderSignupButton() {
    var _emailInputRef$curren2, _emailInputRef$curren3, _cx;
    return /*#__PURE__*/React.createElement(Boutton, {
      variant: "primary",
      onClick: function onClick(e) {
        var _emailInputRef$curren;
        e.preventDefault();
        var emailValue = emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren = emailInputRef.current) === null || _emailInputRef$curren === void 0 ? void 0 : _emailInputRef$curren.value;
        if (!previewMode) {
          if (!isReturningUser) {
            onSubmitCallback({
              end_user_email: emailValue,
              sign_up_method: selectedSSO || 'email'
            });
          }
          processEmail(emailValue);
        }
      },
      disabled: !previewMode && (typeof (emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren2 = emailInputRef.current) === null || _emailInputRef$curren2 === void 0 ? void 0 : _emailInputRef$curren2.value) === 'undefined' || (emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren3 = emailInputRef.current) === null || _emailInputRef$curren3 === void 0 ? void 0 : _emailInputRef$curren3.value) === '') && !selectedSSO,
      className: cx(style.signupButton, (_cx = {}, _cx[style.loginButton] = isReturningUser, _cx))
    }, !isReturningUser ? "Sign up" + (selectedSSO ? " with " + selectedSSO : '') : 'Log in');
  };
  var socialLoginProps = {
    authenticationMethods: authenticationMethods,
    fieldContainerProps: fieldContainerProps,
    origin: origin,
    params: {
      custom_properties: values === null || values === void 0 ? void 0 : values.customFields,
      form_id: popupId,
      newsletter_ids: values === null || values === void 0 ? void 0 : values.newsletters,
      utmParams: utm,
      is_logging_in: isReturningUser
    },
    name: name,
    onLogin: function onLogin(response, meta) {
      setErrorMessage(null);
      onSocialLogin(response, meta);
    },
    publisherId: publisherId,
    userId: userId,
    access_token: access_token,
    scope: 'user',
    linkColor: linkColor
  };
  var hasEmail = authenticationMethods.includes('email');
  var showEmailInput = previewMode || enterEmail;
  var allowSkipOtp = isNewRegistration && isPaymentLandingPage;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("section", {
    className: cx((_cx2 = {}, _cx2[style.isPreview] = previewMode, _cx2)),
    "data-testid": "email-signup"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: style.container
  }, hasEmail && /*#__PURE__*/React.createElement(React.Fragment, null, showEmailInput && /*#__PURE__*/React.createElement("div", {
    className: style.field
  }, /*#__PURE__*/React.createElement(Field, _extends({}, fieldContainerProps, {
    name: name + ".emailAddress",
    type: "text",
    placeholder: "name@domain.com",
    validate: composeValidators(fieldValidations.email)
  }), function (_ref2) {
    var meta = _ref2.meta,
      input = _ref2.input,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
    return /*#__PURE__*/React.createElement("div", {
      className: style.emailInput
    }, /*#__PURE__*/React.createElement(Form.Input, _extends({}, rest, {
      meta: meta,
      ref: emailInputRef,
      input: input,
      onFocus: emailInputOnFocus,
      onKeyDown: function onKeyDown(e) {
        return onEnterEmail(e, e.target.value);
      }
    })));
  })), !showEmailInput && /*#__PURE__*/React.createElement(Otp, {
    checkEmail: checkEmail,
    confirmCode: confirmCode,
    contrastColor: contrastColor,
    customProperties: values === null || values === void 0 ? void 0 : values.customFields,
    email: email,
    fieldContainerProps: fieldContainerProps,
    isNewRegistration: isNewRegistration,
    linkColor: linkColor,
    newsletters: (values === null || values === void 0 ? void 0 : values.newsletters) || [],
    oneTimeCodeError: oneTimeCodeError,
    oneTimeCodeSent: oneTimeCodeSent,
    onSkipOtp: onSkipOtp,
    requestNewCode: requestNewCode,
    resendOneTimeCode: resendOneTimeCode,
    allowSkipOtp: allowSkipOtp
  })), /*#__PURE__*/React.createElement("div", {
    className: style.signup_button
  }, selectedSSO ? /*#__PURE__*/React.createElement(SocialLoginButton, _extends({}, socialLoginProps, {
    type: selectedSSO === 'LinkedIn' ? 'linkedin2' : selectedSSO.toLowerCase(),
    api_url: PICO_API_URL(),
    button: renderSignupButton(),
    onClick: function onClick() {
      if (!isCustomFieldsValid) {
        setErrorMessage(invalidCustomFieldsError);
      } else {
        setErrorMessage(null);
      }
      !isReturningUser && onSubmitCallback({
        sign_up_method: selectedSSO
      });
    },
    previewMode: previewMode || !isCustomFieldsValid,
    onFailure: function onFailure(error) {
      return (error === null || error === void 0 ? void 0 : error.error) && setErrorMessage(error.error);
    },
    isReturningUser: isReturningUser
  })) : showEmailInput ? /*#__PURE__*/React.createElement(React.Fragment, null, !!errorMessage && showError && /*#__PURE__*/React.createElement("div", {
    className: style.error
  }, getErrorText(errorMessage)), renderSignupButton()) : null), showEmailInput && !!authenticationMethods.filter(function (method) {
    return method !== 'email' && method !== 'sms';
  }).length && /*#__PURE__*/React.createElement("div", {
    className: style.social
  }, /*#__PURE__*/React.createElement(Spacing.HorizontalDivider, {
    withLine: true,
    className: style.loginDivider
  }, hasEmail && 'OR ', isReturningUser ? 'LOG IN ' : 'SIGN UP ', "WITH"), selectedSSO && showError && !!errorMessage && /*#__PURE__*/React.createElement("div", {
    className: style.error
  }, getErrorText(errorMessage)), /*#__PURE__*/React.createElement(SocialLogin, _extends({}, fieldContainerProps, socialLoginProps, {
    handleClick: handleDummySSOClick,
    previewMode: !isReturningUser || previewMode,
    selected: selectedSSO,
    onFailure: function onFailure(error) {
      return (error === null || error === void 0 ? void 0 : error.error) && setErrorMessage(error.error);
    }
  }))), showTerms && /*#__PURE__*/React.createElement("div", {
    className: style.terms
  }, "By signing up, you agree to", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://hype.co/terms/user-agreement",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Hype\u2019s Terms"), ' ', " and acknowledge the ", /*#__PURE__*/React.createElement("a", {
    href: "https://hype.co/terms/privacy-policy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"), ".", ' ', " You also agree that ", username, " may send you marketing emails.")))));
};
EmailPasswordSocialNewslettersLogin.propTypes = {
  access_token: PropTypes.string,
  authenticationMethods: PropTypes.array,
  checkEmail: PropTypes.func,
  confirmCode: PropTypes.func,
  contrastColor: PropTypes.string,
  email: PropTypes.string,
  errorMessage: PropTypes.string,
  fieldContainerProps: PropTypes.any,
  getErrorText: PropTypes.func,
  hasUserLoader: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  isCustomFieldsValid: PropTypes.bool,
  isNewRegistration: PropTypes.bool,
  isPaymentLandingPage: PropTypes.bool,
  isReturningUser: PropTypes.bool,
  linkColor: PropTypes.string,
  name: PropTypes.string,
  newsletters: PropTypes.array,
  oneTimeCodeError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  oneTimeCodeSent: PropTypes.bool,
  onSkipOtp: PropTypes.func,
  onSocialLogin: PropTypes.func,
  onSubmitCallback: PropTypes.func,
  origin: PropTypes.string,
  popupId: PropTypes.string,
  previewMode: PropTypes.bool,
  publisherId: PropTypes.string,
  required: PropTypes.bool,
  resendOneTimeCode: PropTypes.func,
  resetOneTimeCode: PropTypes.func,
  setFlow: PropTypes.func,
  showError: PropTypes.bool,
  showTerms: PropTypes.bool,
  updateAccountError: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  userId: PropTypes.string,
  username: PropTypes.string,
  utm: PropTypes.string,
  values: PropTypes.object
};
var MemoizedEmailPasswordSocialNewslettersLogin = /*#__PURE__*/React.memo(EmailPasswordSocialNewslettersLogin);
MemoizedEmailPasswordSocialNewslettersLogin.displayName = 'FieldSignupEmailPasswordSocialNewslettersLogin';
var EmailPasswordSocialNewslettersLogin$1 = MemoizedEmailPasswordSocialNewslettersLogin;

export { EmailPasswordSocialNewslettersLogin$1 as default };
//# sourceMappingURL=index.js.map
